/**
 * Formats the count display for different types of items
 */
export function formatItemCount(count: number, itemType: `page` | `permission` | `user`): string {
  if (count === 0) return `-`
  if (count === 1) return `1 ${itemType}`
  return `${count} ${itemType}s`
}
